export default class Media {
    constructor(client) {
        this.client = client
    }

    async list(data) {
        return this.request('POST', 'list', {data})
    }

    async libraries() {
        return await this.requestv1("GET", "library/list")
    }

    async upload(payload) {
        let files = payload.files
        let formData = new FormData();
        
        let count = 0
        files.forEach((file, index) => {
            let rename = file.rename || file.name
            let orgExt = file.name.split('.')

            rename = `${rename}.${orgExt[orgExt.length - 1]}`

            formData.append('file', file, rename)
            count++
        })

        if (count == files.length) {
            formData.append('path', payload.uploadDir)
            formData.append('ref', payload.uuid)
            if (payload.public) {
                formData.append('is_public', "true")
            }

            if (payload.expiresAt)
                formData.append('expiresAt', new Date(payload.expiresAt).toISOString())

            if (!_.isEmpty(payload.metadata))    
                formData.append('metadata', JSON.stringify(payload.metadata))

            return await this.request("POST", "", {
                data: formData,
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
        }
    }

    async delete(data) {
        return this.request('POST','delete', data)
    }

    async uploadBase64(data) {
        return this.request('POST', ``, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
    }

    async getMedia(lib, key, encoding) {
        return this.request('GET', `library/${lib}/get/${key}`,{
            params: {
                encoding
            },
            responseType: (!encoding) ? 'blob' : null
        })
    }

    async download(lib, key) {
        return this.request('POST', `library/${lib}/download`, {data: {key}}, {
            responseType: 'blob'
        })
    }

    async getExifData(lib, key) {
        return this.request('GET', `library/${lib}/exif/${key}`)
    }

    async html2pdf(lib, data) {
        const { 
            output_pdf = false,
            input_path,
            input_html,
            output_path,
            output_file_name,
            data: templateData
        } = data

        const type = output_pdf ? 'arraybuffer' : 'json'
        const contentType = output_pdf ? 'application/pdf' : 'application/json'

        return this.request('POST', `library/${lib}/html2pdf`, {
            data: {
                output_pdf,
                input_path,
                output_path,
                input_html,
                output_file_name,
                data: templateData
            },

            headers: {
                'Content-Type': contentType
            },

            responseType: type
        })
    }

    async createDir(lib, path) {
        return this.request('POST', `library/${lib}/dir`, {data: {path}})
    }

    async deleteDir(lib, path) {
        return this.request('POST', `library/${lib}/delete/dir`, {data: {path}})
    }

    async dirs(lib, data) {
        return await this.request("POST", `library/${lib}/dirs`, {data})
    }

    async request(method, endpoint, params) {
        return await this.client.request({
            method: method,
            url: "/v2/media/" + endpoint,
            ...params
        })
    } 

    async requestv1(method, endpoint, params) {
        return await this.client.request({
            method: method,
            url: "/v1/media/" + endpoint,
            ...params
        })
    } 
}